<template>
  <!-- 头像 -->
  <div class="navigateDrop">
    <a-dropdown
      class="drop"
      trigger="click"
      placement="bottomRight"
      @visibleChange="visibleChange"
    >
      <div class="head">
        <img
          v-if="userInfo.profilePhoto"
          :src="userInfo.profilePhoto"
          @error="defImg"
          alt=""
          class="header-user-avatar-image"
        />
        <img
          v-else
          src="../../../images/default_user_head.png"
          alt=""
          class="header-user-avatar-image"
        />
      </div>
      <template #overlay>
        <div class="user-panel">
          <div class="user-panel-name display-flex">
            <div class="user-panel-name-avatar">
              <img
                :src="userInfo.profilePhoto"
                class="photoUrl"
                @error="defImg"
              />
            </div>
            <div class="flex-1 margin-l-20">
              <p
                class="font-size-16 color-333 weight-600 white-1"
                style="width: 190px"
              >
                {{ userInfo.nickname }}
              </p>
              <p class="font-size-12 color-999 margin-t-3">
                {{ userInfo.phone || userInfo.email }}
              </p>
            </div>
          </div>
          <ul class="user-panel-list margin-t-10">
            <li
              class="font-size-14 color-666 display-flex align-center justify-between"
              @click="wealth"
              v-if="enterpriseGlobalId == 'personal'"
            >
              <div>
                <svg aria-hidden="true" class="drop-icon">
                  <use xlink:href="#icon-navyili"></use>
                </svg>
                <span class="margin-l-8">译力余额：{{ etoken }}</span>
              </div>
              <a-button
                type="link"
                size="small"
                class="font-size-14"
                style="padding: 0"
                @click.stop="toChargeFunc"
              >
                充值
              </a-button>
            </li>
            <li class="font-size-14 color-666" @click="userCenter">
              <svg aria-hidden="true" class="drop-icon">
                <use xlink:href="#icon-navgerenzhongxin"></use>
              </svg>
              <span class="margin-l-8">个人中心</span>
            </li>
            <div class="line"></div>
          </ul>
          <div
            class="user-panel-layout font-size-14 color-bbb"
            @click="handleLogout"
          >
            安全退出
          </div>
        </div>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
  import { defineComponent, computed, onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  import { getEtoken } from '@/http/api'

  export default defineComponent({
    setup() {
      const router = useRouter()
      const store = useStore()
      const userInfo = computed(() => store.state.user.userInfo)
      const enterpriseGlobalId = computed(
        () => store.state.comm.enterpriseGlobalId
      )

      const etoken = ref('')

      // 跳转数据资产
      const handleToPage = (v) => {
        const urlObj = {
          invite: window.env.wordpower + '/invite',
          asset: window.env.wordpower + '/wealth',
          myReport: window.env.wordpower + '/myReport',
          userCenter: window.env.wordpower + '/userCenter',
        }
        window.open(urlObj[v], '_blank')
      }

      // 退出登录
      const handleLogout = () => {
        store.dispatch('user/logout').then((res) => {
          // 清除userInfo信息
          store.commit('user/changeKey', {
            userInfo: {},
          })
          // 清除我的收藏信息
          store.commit('comm/changeKey', {
            favoriteList: {},
          })
          store.dispatch('user/getDictionary')
          router.push('/home')
        })
      }

      // 失败设置默认头像
      const defImg = () => {
        let img = event.srcElement
        img.src = require('../../../images/default_user_head.png')
        img.onerror = null //防止闪图
      }

      // 个人中心
      const userCenter = () => {
        let url = ''
        if (enterpriseGlobalId.value == 'personal') {
          url = '/go/tsp_pc_login/center'
        } else {
          url = '/go/tsp_pc_login/center?customCenter=1'
        }
        window.open(url, '_blank')
      }

      // 获取译力余额
      const getEtokenFunc = () => {
        getEtoken().then((res) => {
          const data = res.data.data
          etoken.value = data.etoken
        })
      }

      // 前往充值
      const toChargeFunc = () => {
        window.open('/go/wealth_pc_login/recharge', '_blank')
      }

      // 显示与隐藏
      const visibleChange = (val) => {
        if (val) {
          store.dispatch('user/checkToken')
        }
      }

      onMounted(() => {
        getEtokenFunc()
      })

      return {
        userInfo,
        etoken,
        enterpriseGlobalId,
        handleToPage,
        handleLogout,
        defImg,
        userCenter,
        toChargeFunc,
        visibleChange,
      }
    },
  })
</script>

<style scoped lang="less">
  .navigateDrop {
    .head {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      outline: none;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .el-dropdown-menu {
    padding: 0;
  }

  // 头像下拉
  .user-panel {
    user-select: none;
    .head {
      text-align: center;
      padding: 20px 20px 10px;
      width: 312px;
      background: url('./../../../images/uc_bg.png') no-repeat center;
      background-size: cover;
      .photoUrl {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        margin-bottom: 10px;
        border: 2px solid #ffffff;
      }
      .nickName {
        font-size: 18px;
        font-weight: bold;
        color: #161b36;
        line-height: 25px;
        margin-bottom: 4px;
      }
      .phone,
      .email {
        font-size: 14px;
        color: rgba(72, 77, 102, 0.6);
        line-height: 20px;
      }
    }
    .option {
      padding: 0 20px;
      .option-sign {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 20px 0;
        border-bottom: 1px solid #ebedf0;
        .sign-item {
          padding: 10px 0;
          width: 33.33%;
          height: 109px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background: #f4f7ff;
            border-radius: 10px;
          }
          svg {
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
          }
          p:nth-of-type(1) {
            font-size: 14px;
            color: #161b36;
            line-height: 20px;
            margin-bottom: 2px;
          }
          p:nth-of-type(2) {
            font-size: 12px;
            color: #8589a0;
            line-height: 17px;
          }
        }
      }
      .option-link {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        .link-item {
          font-size: 14px;
          color: #374567;
          cursor: pointer;
          svg {
            width: 14px;
            height: 14px;
            fill: #8589a0;
            margin-right: 4px;
          }
          &:hover {
            color: #347eff;
            svg {
              fill: #347eff;
            }
          }
        }
      }
    }
  }
  .user-panel {
    width: 320px;
    padding: 20px 20px 0 20px;
    background: #fff;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    margin-top: 15px;
    .user-panel-name {
      .user-panel-name-avatar {
        flex: 0 0 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .user-panel-level {
      .level-item {
        padding: 12px 0;
        width: 130px;
        height: 66px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: translateY(-4px);
        }
        &.person-free {
          background: linear-gradient(180deg, #e7f6ff 0%, #f3f9fe 100%);
        }
        &.person-premium {
          background: linear-gradient(180deg, #e7f2ff 0%, #f3f6fe 100%);
        }
        &.team-free {
          background: linear-gradient(180deg, #e7f6ff 0%, #f3f9fe 100%);
        }
        &.team-startup {
          background: linear-gradient(180deg, #e7f2ff 0%, #f3f6fe 100%);
        }
        &.team-enterprise {
          background: linear-gradient(180deg, #fff3e7 0%, #fef8f3 100%);
        }
        &.team-ultimate {
          background: linear-gradient(180deg, #e6ebff 0%, #f4f2ff 100%);
        }
        &.team-ultimate-plus {
          background: linear-gradient(180deg, #e7e6ff 0%, #f8f2ff 100%);
        }
        .time {
          font-size: 12px;
          color: #bbb;
        }
      }
    }
    .user-panel-list {
      li {
        padding: 0 12px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        &:hover {
          background: #f4f6f7;
          border-radius: 6px;
        }
      }
      .line {
        width: 100%;
        height: 10px;
        border-bottom: 1px solid #eeeeee;
      }
    }
    .user-panel-layout {
      line-height: 44px;
      text-align: center;
      cursor: pointer;
      &:hover {
        color: #f55c3f !important;
      }
    }
  }
</style>
